import { render, staticRenderFns } from "./CategoryCartStatusBar.vue?vue&type=template&id=4f7fc574&scoped=true&"
import script from "./CategoryCartStatusBar.vue?vue&type=script&lang=js&"
export * from "./CategoryCartStatusBar.vue?vue&type=script&lang=js&"
import style0 from "./CategoryCartStatusBar.vue?vue&type=style&index=0&id=4f7fc574&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f7fc574",
  null
  
)

export default component.exports